// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {Blog, Blog_editor} from './resolvers/blog';
import {Article, Article_editor} from './resolvers/article';
import {Title, Title_editor} from './resolvers/title';
import {Spacer, Spacer_editor} from './resolvers/spacer';
import {Products_tabs, Products_tabs_editor} from './resolvers/products_tabs';
import {Features, Features_editor} from './resolvers/features';
import {Cards, Cards_editor} from './resolvers/cards';
import {Paragraph, Paragraph_editor} from './resolvers/paragraph';
import {Cta, Cta_Editor} from './resolvers/cta';
import {Image, Image_editor} from './resolvers/image';
import {Countries, Countries_editor} from './resolvers/countries';
import {Store_review, Store_review_editor} from './resolvers/review';
import {Faq, Faq_editor} from './resolvers/faq';
import {Product_hero, Product_hero_editor} from './resolvers/product_hero';
import {One_review, One_review_editor} from './resolvers/one_review';
import {Breadcrumbs, Breadcrumbs_editor} from './resolvers/breadcrumbs';
import {Help_tiles, Help_tiles_editor} from './resolvers/help_tiles';
import {Contact_us, Contact_us_editor} from './resolvers/contact_us';
import {Plans_as_boxes,
    Plans_as_boxes_editor} from './resolvers/plans_as_boxes';
import {Navigation_button,
    Navigation_button_editor} from './resolvers/navigation_button';
import {Link_buttons, Link_buttons_editor} from './resolvers/link_buttons';
import {Change_plan_form,
    Change_plan_form_editor} from './resolvers/change_plan_form';
import {Accordion, Accordion_editor} from './resolvers/accordion';
import {Refund_btn, Refund_btn_editor} from './resolvers/refund_button';
import {Download_browser_banner, Download_browser_banner_editor}
    from './resolvers/download_browser_banner';
import {How_it_works_impl,
    How_it_works_editor} from './resolvers/how_it_works_banner';
import {Dont_take_banner,
    Dont_take_banner_editor} from './resolvers/dont_take_banner';
import {Product_browser_media,
    Product_browser_media_editor} from './resolvers/product_browser_media';
import {Html, Html_editor} from '../../hola/pub/lib/html';
import {Browser_faq, Browser_faq_editor} from './resolvers/browser_faq';
import {No_image_download_banner, No_image_download_banner_editor}
    from './resolvers/no_image_download_banner';
import {Premium_support_form,
    Premium_support_form_editor} from './resolvers/premuim_support_form';
import {Contact_us_cards,
    Contact_us_cards_editor} from './resolvers/contact_us_cards';
import {Office_location_banner,
    Office_location_banner_editor} from './resolvers/office_location_banner';
import {Hero_info, Hero_info_editor} from './resolvers/hero_info';
import {Access_for_all,
    Access_for_all_editor} from './resolvers/access_for_all_banner';
import {Timeline_animation,
    Timeline_animation_editor} from './resolvers/timeline_animation';
import {About_product,
    About_product_editor} from './resolvers/about_product_banner';
import {About_media, About_media_editor} from './resolvers/about_media_banner';
import {Payment_form, Payment_form_editor} from './resolvers/payment_form';
import {Vpn_country_hero,
    Vpn_country_hero_editor} from './resolvers/vpn_country_hero';
import {Ips, Ips_editor} from './resolvers/ips';
import {Vpn_access_steps,
    Vpn_access_steps_editor} from './resolvers/vpn_access_steps';
import {Global_content,
    Global_content_editor} from './resolvers/global_content';
import {You_love_country_vpn,
    You_love_country_vpn_editor} from './resolvers/you_love_country_vpn';
import {Highest_rated, Highest_rated_editor} from './resolvers/highest_rated';
import {Download_vpn_banner,
    Download_vpn_banner_editor} from './resolvers/download_vpn_banner';
import {Discover_hero, Discover_hero_editor} from './resolvers/discover_hero';
import {Lp_iframe_template,
    Lp_iframe_template_editor} from './resolvers/lp_iframe_template';
import {Feature_cards, Feature_cards_editor} from './resolvers/feature_cards';
import {Free_vpn_hero, Free_vpn_hero_editor} from './resolvers/free_vpn_hero';
import {Reliability_banner,
    Reliability_banner_editor} from './resolvers/reliability_banner';
import {Stores_reviews,
    Stores_reviews_editor} from './resolvers/stores_reviews';
import {Blog_post, Blog_post_editor} from './resolvers/blog_post';
import {Go_beyond_banner,
    Go_beyond_banner_editor} from './resolvers/go_beyond_banner';
import {Related_articles,
    Related_articles_editor} from './resolvers/related_articles';
import {How_it_works_2,
    How_it_works_2_editor} from './resolvers/how_it_works_2';
import {Choose_your_vpn_cards,
    Choose_your_vpn_cards_editor} from './resolvers/choose_your_vpn_cards';
import {Free_vs_premium,
    Free_vs_premium_editor} from './resolvers/free_vs_premium';
import {Explore_network,
    Explore_network_editor} from './resolvers/explore_network';
import {Get_started_banner,
    Get_started_banner_editor} from './resolvers/get_started_banner';
import {Vpn_products_hero,
    Vpn_products_hero_editor} from './resolvers/vpn_products_hero';
import {Compare_table, Compare_table_editor} from './resolvers/compare_table';
import {Access_domain_hero,
    Access_domain_hero_editor} from './resolvers/access_domain_hero';
import {About_domain_banner,
    About_domain_banner_editor} from './resolvers/about_domain_banner';
import {Popular_locations_for_domain,
    Popular_locations_for_domain_editor}
        from './resolvers/popular_locations_for_domain';
import {Agreement_message,
    Agreement_message_editor} from './resolvers/agreement_message';
import {Mini_footer, Mini_footer_editor} from './resolvers/mini_footer';
import {Relative_domains_banner,
    Relative_domains_banner_editor} from './resolvers/relative_domains_banner';
import {Access_problem_tips,
    Access_problem_tips_editor} from './resolvers/access_problem_tips';
import {Access_popular} from './resolvers/access_popular';
import {Game_boost_hero,
    Game_boost_hero_editor} from './resolvers/game_boost_hero';
import {Stop_losing_banner,
    Stop_losing_banner_editor} from './resolvers/stop_losing_banner';
import {Coming_soon_banner,
    Coming_soon_banner_editor} from './resolvers/coming_soon_banner';
import {Fast_pace_gaming_banner,
    Fast_pace_gaming_banner_editor} from './resolvers/fast_pace_gaming_banner';
import {Popular_games_banner,
    Popular_games_banner_editor} from './resolvers/popular_games_banner';
import {Game_boost_why_free_banner,
    Game_boost_why_free_banner_editor} from
    './resolvers/game_boost_why_free_banner';
import {Game_boost_works_with_popular_games,
    Game_boost_works_with_popular_games_editor} from
    './resolvers/game_boost_works_with_popular_games';


import {Bounty_hero,
    Bounty_hero_editor} from './resolvers/bounty_hero';
import {Bounty_program_scope,
    Bounty_program_scope_editor} from './resolvers/bounty_program_scope';
import {Bounty_reward_tiers,
    Bounty_reward_tiers_editor} from './resolvers/bounty_reward_tiers';
import {Bounty_vulnerability_criteria,
    Bounty_vulnerability_criteria_editor}
    from './resolvers/bounty_vulnerability_criteria';
import {Bounty_bug_reporting,
    Bounty_bug_reporting_editor} from './resolvers/bounty_bug_reporting';
import {Bounty_security_guidelines,
    Bounty_security_guidelines_editor}
    from './resolvers/bounty_security_guidelines';
import {Bounty_payments,
    Bounty_payments_editor} from './resolvers/bounty_payments';
import {Bounty_cta,
    Bounty_cta_editor} from './resolvers/bounty_cta';


export const static_resolvers = {
    'Html': {
        tag: Html,
        editor: Html_editor,
        props: {
            html: `<h2>Title</h2><p>Text in p1</p>
              <p class="p2">Text in p.p2</p>
              <p class="p12 semi">Text with class p12 and semi</p>`,
        },
    },
    'Spacer': {
        tag: Spacer,
        editor: Spacer_editor,
        props: {
            margin: 16,
            margin_tablet: 16,
            margin_mobile: 16,
            unit: 'px',
        },
    },
    'Title': {
        tag: Title,
        editor: Title_editor,
        props: {
            gradient: false,
            title: 'Title',
            subtitle: 'Subtitle',
        },
    },
    'Cta': {
        tag: Cta,
        editor: Cta_Editor,
        props: {
            gradient: false,
            title: 'Title',
            subtitle: 'Subtitle',
        },
    },
    'Image': {
        tag: Image,
        editor: Image_editor,
        props: {
            gradient: false,
            img: 'http://hola.org/cms/wp-content/uploads/2024/09/'
                +'fastwatch_img.png',
        },
    },
    'Products_tabs': {
        tag: Products_tabs,
        editor: Products_tabs_editor,
        props: {
            browsers: true,
            mobile: true,
            desktop: true,
            tv: true,
            other: true,
        },
    },
    'Features': {
        tag: Features,
        editor: Features_editor,
        props: {
            title: 'You\'ll love Hola',
            features: [{
                title: 'Ultra-fast and stable connection',
                description: 'Our high-speed stable network will get you '
                    +'the best connectivity out there!',
                image: 'http://hola.org/cms/wp-content/uploads/2024/09/'
                    +'fastwatch_img.png',
            },
            {
                title: 'Use across all your devices',
                description: 'Use Hola on your tablet, TV, laptop,'+
                    ' or phone with our selection of apps!',
                image: 'http://hola.org/cms/wp-content/uploads/2024/09/'
                    +'devices_img.png',
            },
            {
                title: '24/7 Customer Support Center',
                description: 'Get in touch anytime. We\'re there whenever '
                    +'you need us!',
                image: 'http://hola.org/cms/wp-content/uploads/2024/09/'
                    +'support_img.png',
            },]
        },
    },
    'Cards': {
        tag: Cards,
        editor: Cards_editor,
        props: {
            title: 'Need Help?',
            cards: [{
                link: '',
                description: 'Our high-speed stable network will get you '
                    +'the best connectivity out there!',
                image: 'http://hola.org/cms/wp-content/uploads/2024/09/'
                    +'fastwatch_img.png',
            },
            {
                link: '/premium_support',
                description: 'Use Hola on your tablet, TV, laptop, or'
                    +' phone with our selection of apps!',
                image: 'http://hola.org/cms/wp-content/uploads/2024/09/'
                    +'devices_img.png',
            },]
        },
    },
    'Paragraph': {
        tag: Paragraph,
        editor: Paragraph_editor,
        props: {
            title: 'Your internet is truly yours with Hola Premium',
            text: 'Our mission is to create a truly borderless internet—one'+
                ' that is free',
            image: 'http://hola.org/cms/wp-content/uploads/2024/09/'
                +'devices_img.png',
            image_left: true,
        },
    },
    'Countries': {
        tag: Countries,
        editor: Countries_editor,
        props: {
            title: 'Your internet is truly yours with Hola Premium',
            description: 'Our mission is to create a truly borderless'+
                ' internet—one that is free',
            bg_color: null,
        },
    },
    'Store_review': {
        tag: Store_review,
        editor: Store_review_editor,
        props: {
            title: 'Your internet is truly yours with Hola Premium',
            store: 'App Store',
            store_img: '',
        },
    },
    'Faqs': {
        tag: Faq,
        editor: Faq_editor,
        props: {
            title: 'Common questions people ask',
            faqs: [],
        },
    },
    'Product_hero': {
        tag: Product_hero,
        editor: Product_hero_editor,
        props: {
            src: 'Common questions people ask',
        },
    },
    'One_review': {
        tag: One_review,
        editor: One_review_editor
    },
    'Blog': {
        tag: Blog,
        editor: Blog_editor,
        props: {category: '', per_page: 9, page: 1, title: 'Blog'}
    },
    'Article': {
        tag: Article,
        editor: Article_editor,
        props: {slug: '', id: '', show_meta: true, title: 'Article'}
    },
    'Breadcrumbs': {
        tag: Breadcrumbs,
        editor: Breadcrumbs_editor,
        props: {breadcrumbs: [{title: '', link: ''}]}
    },
    'Help Tiles': {
        tag: Help_tiles,
        editor: Help_tiles_editor,
        props: {tiles: [{title: '', link: ''}]}
    },
    'Contact us banner': {
        tag: Contact_us,
        editor: Contact_us_editor,
        props: {title: '', subtitle: '', cta: '', link: ''}
    },
    'Plans as boxes': {
        tag: Plans_as_boxes,
        editor: Plans_as_boxes_editor,
        props: {trans: {title: '', subtitle: '', cta: ''}}
    },
    'Navigation button': {
        tag: Navigation_button,
        editor: Navigation_button_editor,
        props: {button_title: '', link: '', with_arrow_back: false}
    },
    'Button links': {
        tag: Link_buttons,
        editor: Link_buttons_editor,
        props: {
            is_in_center: false, is_accordion_like: false,
            buttons: [{cta: '', link: '', is_transparent: false}],
        }
    },
    'Change plan form': {
        tag: Change_plan_form,
        editor: Change_plan_form_editor,
        props: {next_step_link: ''}
    },
    'Accordion': {
        tag: Accordion,
        editor: Accordion_editor,
        props: {items: [{question: '', answer: ''}], cols: 1}
    },
    'Refund button': {
        tag: Refund_btn,
        editor: Refund_btn_editor,
        props: {success_url: '', fail_url: '', cta: '',
            policy: '', is_in_center: false, is_check_refund: true}
    },
    'Download browser banner': {
        tag: Download_browser_banner,
        editor: Download_browser_banner_editor,
        props: {title: '', subtitle: '', button_text: '', render_images: true}
    },
    'How it works banner': {
        tag: How_it_works_impl,
        editor: How_it_works_editor
    },
    'Dont take banner': {
        tag: Dont_take_banner,
        editor: Dont_take_banner_editor
    },
    'Product browser media': {
        tag: Product_browser_media,
        editor: Product_browser_media_editor
    },
    'Browser faq': {
        tag: Browser_faq,
        editor: Browser_faq_editor
    },
    'No image download banner': {
        tag: No_image_download_banner,
        editor: No_image_download_banner_editor
    },
    'Premium support form': {
        tag: Premium_support_form,
        editor: Premium_support_form_editor,
        props: {title: '', subtitle: ''}
    },
    'Contact us cards': {
        tag: Contact_us_cards,
        editor: Contact_us_cards_editor
    },
    'Office location banner': {
        tag: Office_location_banner,
        editor: Office_location_banner_editor
    },
    'Hero info': {
        tag: Hero_info,
        editor: Hero_info_editor,
        props: {
            h1: 'About Hola: Making the Internet Borderless',
            h2_1: 'Internet Freedom.',
            h2_2: 'It’s what we’re about.',
            h2_3: 'It is who we are.'
        },
    },
    'Access for all banner': {
        tag: Access_for_all,
        editor: Access_for_all_editor
    },
    'Timeline animation': {
        tag: Timeline_animation,
        editor: Timeline_animation_editor
    },
    'About product banner': {
        tag: About_product,
        editor: About_product_editor,
        props: {title: '', subtitle: ''}
    },
    'About media banner': {
        tag: About_media,
        editor: About_media_editor
    },
    'Payment form': {
        tag: Payment_form,
        editor: Payment_form_editor,
    },
    'Vpn Country Hero': {
        tag: Vpn_country_hero,
        editor: Vpn_country_hero_editor
    },
    'Ips': {
        tag: Ips,
        editor: Ips_editor
    },
    'Vpn access steps': {
        tag: Vpn_access_steps,
        editor: Vpn_access_steps_editor
    },
    'Global content': {
        tag: Global_content,
        editor: Global_content_editor
    },
    'You`ll love country vpn': {
        tag: You_love_country_vpn,
        editor: You_love_country_vpn_editor
    },
    'Highest rated': {
        tag: Highest_rated,
        editor: Highest_rated_editor
    },
    'Download VPN banner': {
        tag: Download_vpn_banner,
        editor: Download_vpn_banner_editor
    },
    'Discover hero': {
        tag: Discover_hero,
        editor: Discover_hero_editor,
        props: {
            title: 'Hola, because Access shouldn\'t depend on where you are.',
            subtitle: 'In your pocket, while on the go, on your desktop or '
                +'Smart TV, Hola is there to get you the content you want, no '
                +'matter what device you prefer.'
        },
    },
    'Feature cards': {
        tag: Feature_cards,
        editor: Feature_cards_editor,
    },
    'Free vpn hero': {
        tag: Free_vpn_hero,
        editor: Free_vpn_hero_editor,
        props: {
            title: 'Hola Free VPN for Fast, Easy Access Worldwide',
            subtitle: 'Install Hola VPN for free and enjoy worldwide content'
                +' in seconds.',
            cta1: 'Get Hola Free VPN',
            cta2: 'See Premium',
        },
    },
    'Reliability banner': {
        tag: Reliability_banner,
        editor: Reliability_banner_editor,
    },
    'Stores reviews': {
        tag: Stores_reviews,
        editor: Stores_reviews_editor,
    },
    'Blog post': {
        tag: Blog_post,
        editor: Blog_post_editor,
        props: {
            category: 'How to',
            category_url: 'https://hola.org/blog/how-to',
            read_time: '12 min read',
            publish_date: 'Jun 14, 2021',
            title: 'Ride the Crypto Wave: Why a VPN is Your Essential '
                +'Companion',
            image_url: 'https://files.nc.gov/nc-wildlife/styles/event_image'
                +'/public/images/2025-07/whitetaileddeer_USFWS_r.jpg'
                +'?VersionId=xcVpcdsGuzcu1mSYds9XR9oZLjBuFoMQ&itok=7DxygCmo',
            image_alt: 'Deer standing in a field',
            author_name: 'Hola Writer',
            author_avatar: 'https://encrypted-tbn0.gstatic.com/images?'
                +'q=tbn:ANd9GcRyaS9dW15PMOAWf9oneAPmq-Fys0W8w3nPXC7wZ36CROlJ3t'
                +'kNFb0_9uz5CI7h98cHIzOUupljRsENdsXzDLtFfJ-mMB_KHcl7TjZGD8qoXg'
                +'&s=10',
            share_url: 'https://hola.org/blog/how-to/sample-article',
            article_html: '<h2 id="what-is-hola-vpn">What is Hola VPN?</h2>'
                +'<p>In today\'s digital age, streaming services have '
                +'revolutionized how we consume entertainment. They\'ve '
                +'created a new stream of access to some of our favorite '
                +'series and movies. Cool, right? However, many of us have '
                +'experienced the frustration of not being able to access '
                +'certain shows or movies due to regional restrictions '
                +'(boo!).</p>'
                +'<h3 id="what-is-hola-vpn_subitem1">Privacy Protection</h3>'
                +'<p>But fear not! We\'re going to show you how to unlock a '
                +'treasure trove of region-exclusive TV shows using Hola VPN. '
                +'Let\'s go borderless, let\'s go beyond regions!</p>'
                +'<h3 id="what-is-hola-vpn_subitem2">Secure Connection</h3>'
                +'<p>Your connection is encrypted and secure, protecting your '
                +'data from prying eyes and potential threats.</p>'
                +'<h3 id="what-is-hola-vpn_subitem3">Fast Speeds</h3>'
                +'<p>Enjoy ultra-fast speeds for streaming, browsing, and '
                +'downloading without interruptions.</p>'
                +'<h2 id="why-choose-hola-vpn">Why Choose Hola VPN?</h2>'
                +'<p>Hola VPN stands out from the competition with its unique '
                +'peer-to-peer network architecture and commitment to user '
                +'privacy.</p>'
                +'<h3 id="why-choose-hola-vpn_subitem1">Easy to Use</h3>'
                +'<p>Simple installation process and intuitive interface make '
                +'it accessible for everyone.</p>'
                +'<h3 id="why-choose-hola-vpn_subitem2">Multi-Device '
                +'Support</h3>'
                +'<p>Use Hola VPN on all your devices - desktop, mobile, '
                +'tablet, and even Smart TV.</p>'
                +'<h2 id="how-to-get-started">How to Get Started with Hola '
                +'VPN</h2>'
                +'<ol><li>Sign Up and Install: Begin by '
                +'signing up for a Hola VPN account and installing the '
                +'application on your preferred device. Hola VPN is '
                +'compatible with Windows, macOS, Android, iOS, your Smart '
                +'TVs and more!</li><li>Choose Your Location:'
                +' Open the Hola VPN app and select the region where your '
                +'desired content is accessible.</li><li><strong>Start '
                +'Binge-Watching!:</strong> Once connected, you can now enjoy '
                +'region-exclusive TV shows from the comfort of your own home.'
                +' So break out the popcorn, get comfy on the sofa and press '
                +'play!</li></ol>'
                +'<img src="https://ubirds.by/wp-content/uploads/2020/05/'
                +'Upupa-epops-1.jpg" alt="bird" />'
                +'<h2 id="tips-for-optimal-experience">Tips for an Optimal '
                +'Experience</h2>'
                +'<p>Make the most of your VPN experience with these helpful '
                +'tips and best practices.</p>'
                +'<h2 id="stay-safe-and-legal">Stay Safe and Legal</h2>'
                +'<p>Always remember to use VPN services responsibly and in '
                +'accordance with local laws and regulations.</p>'
                +'<table class="has-fixed-layout"><tbody><tr><td><strong>'
                +'Netflix Library</strong></td><td><strong>Hola VPN Server '
                +'Location</strong></td><td><strong>Key Content Access'
                +'</strong></td></tr><tr><td><strong>US Netflix</strong> '
                +'(Largest Library)</td><td>United States</td><td>Access to '
                +'the biggest catalog of major movies and shows.</td></tr>'
                +'<tr><td><strong>UK Netflix</strong></td><td>United Kingdom'
                +'</td><td>Access to UK-specific content and exclusives.</td>'
                +'</tr><tr><td><strong>Japan Netflix</strong></td><td>Japan'
                +'</td><td>Access to large libraries of regional anime and '
                +'foreign films.</td></tr><tr><td>Canada Netflix'
                +'</td><td>Canada</td><td>Strong selection of '
                +'licensed content and films.</td></tr><tr><td><strong>'
                +'Australia Netflix</strong></td><td>Australia</td><td>Unique '
                +'film library and premium content.</td></tr><tr><td><strong>'
                +'Germany Netflix</strong></td><td>Germany</td><td>'
                +'Well-rounded catalog with European titles.</td></tr><tr><td>'
                +'<strong>South Korea Netflix</strong></td><td>South Korea'
                +'</td><td>High number of award-winning titles and local '
                +'content.</td></tr></tbody></table>',
        }
    },
    'Go beyond banner': {
        tag: Go_beyond_banner,
        editor: Go_beyond_banner_editor,
        props: {
            header: 'Go Beyond Your Location. Access Worldwide Content.',
            subheader: 'Hola is the gateway to your favorite movies, shows, '
            +'games and more, no matter where you live!',
            cta: 'Get Hola - it’s free',
        }
    },
    'Related articles': {
        tag: Related_articles,
        editor: Related_articles_editor,
        props: {
            title: 'Related Articles',
            cards: [
                {
                    article_url: '',
                    img_src: 'https://ubirds.by/wp-content/uploads/2020/05/'
                        +'Upupa-epops-1.jpg',
                    publish_date: 'Oct. 10, 2023',
                    title: 'Globalizing Your Social Media: Hola VPN’s Role'
                        +'in Cross-Cultural Connections',
                    category: 'Others',
                    category_url: 'https://hola.org/blog/others',
                    read_time: '3 mins',
                },
            ],
        },
    },
    'How it works 2': {
        tag: How_it_works_2,
        editor: How_it_works_2_editor
    },
    'Choose your vpn cards': {
        tag: Choose_your_vpn_cards,
        editor: Choose_your_vpn_cards_editor,
        props: {
            title: 'Choose your Hola VPN',
            description: `Get started free on browsers and devices.
                One click to install, instant access.`,
            with_badges: true
        }
    },
    'Free vs premium': {
        tag: Free_vs_premium,
        editor: Free_vs_premium_editor
    },
    'Explore network': {
        tag: Explore_network,
        editor: Explore_network_editor
    },
    'Get started banner': {
        tag: Get_started_banner,
        editor: Get_started_banner_editor,
        props: {
            title: 'Get Started with Hola VPN Today',
            subtitle: 'Install Hola VPN for free and enjoy worldwide content.',
            cta1: 'Get Hola Free VPN',
            cta2: 'See Premium',
        },
    },
    'Vpn products hero': {
        tag: Vpn_products_hero,
        editor: Vpn_products_hero_editor,
    },
    'Compare table': {
        tag: Compare_table,
        editor: Compare_table_editor,
        props: {
            header: 'Compare Hola VPN products'
        }
    },
    'Access domain hero': {
        tag: Access_domain_hero,
        editor: Access_domain_hero_editor,
    },
    'About domain banner': {
        tag: About_domain_banner,
        editor: About_domain_banner_editor
    },
    'Popular locations for domain': {
        tag: Popular_locations_for_domain,
        editor: Popular_locations_for_domain_editor
    },
    'Agreement message': {
        tag: Agreement_message,
        editor: Agreement_message_editor
    },
    'Mini footer': {
        tag: Mini_footer,
        editor: Mini_footer_editor
    },
    'Relative domains banner': {
        tag: Relative_domains_banner,
        editor: Relative_domains_banner_editor,
    },
    'Access problem tips': {
        tag: Access_problem_tips,
        editor: Access_problem_tips_editor,
    },
    'Access popular': {
        tag: Access_popular
    },
    'Game boost hero': {
        tag: Game_boost_hero,
        editor: Game_boost_hero_editor,
        props: {
            title: 'Kill Lag Instantly. For Free.',
            subtitle: 'Our smart routing automatically finds the fastest '
                +'path to any game server. Zero setup, zero cost.',
            button_text: 'Download Free for Windows',
        },
    },
    'Stop losing banner': {
        tag: Stop_losing_banner,
        editor: Stop_losing_banner_editor,
        props: {
            title: 'Stop Losing Games to Lag',
        },
    },
    'Coming soon banner': {
        tag: Coming_soon_banner,
        editor: Coming_soon_banner_editor,
        props: {
            title: 'Coming Soon:',
        },
    },
    'Game boost why free banner': {
        tag: Game_boost_why_free_banner,
        editor: Game_boost_why_free_banner_editor,
        props: {
            label: 'Why is it Free?',
            text: 'GameBoost stays 100% free by utilizing idle, unused'
                +' network bandwidth via Bright Data.',
            highlight_blue: 'No ads,',
            highlight_pink: 'no data selling,',
            highlight_green: 'zero impact on ping',
        },
    },
    'Game boost works with popular games': {
        tag: Game_boost_works_with_popular_games,
        editor: Game_boost_works_with_popular_games_editor,
        props: {
            title: 'Works With Popular Games',
            button_text: 'Download Now',
            rows: [
                {chips: [
                    {name: 'Fortnite', color: 'blue'},
                    {name: 'Warzone', color: 'pink'},
                    {name: 'Minecraft', color: 'orange'},
                    {name: 'Counter-Strike 2', color: 'green'},
                    {name: 'League of Legends', color: 'yellow'},
                    {name: 'FC 25', color: 'orange'},
                    {name: 'Genshin Impact', color: 'pink'},
                    {name: 'Apex Legends', color: 'blue'},
                    {name: 'Valorant', color: 'pink'},
                    {name: 'Grand Theft Auto V', color: 'green'},
                ]},
                {chips: [
                    {name: 'Valorant', color: 'pink'},
                    {name: 'Warframe', color: 'blue'},
                    {name: 'War Thunder', color: 'yellow'},
                    {name: 'Dota 2', color: 'blue'},
                    {name: 'Roblox', color: 'pink'},
                    {name: 'Path of Exile', color: 'orange'},
                    {name: 'Counter-Strike 2', color: 'green'},
                    {name: 'Cricket 26', color: 'pink'},
                    {name: 'Grand Theft Auto V', color: 'green'},
                    {name: 'Aniimo', color: 'yellow'},
                ]},
                {chips: [
                    {name: 'Roblox', color: 'pink'},
                    {name: 'Apex Legends', color: 'blue'},
                    {name: 'For Honor', color: 'orange'},
                    {name: 'The Sims 4', color: 'yellow'},
                    {name: 'Fortnite', color: 'blue'},
                    {name: 'Genshin Impact', color: 'green'},
                    {name: 'Dota 2', color: 'blue'},
                    {name: 'League of Legends', color: 'yellow'},
                    {name: 'Warzone', color: 'pink'},
                    {name: 'Minecraft', color: 'orange'},
                ]},
            ],
        },
    },
    'Fast pace gaming banner': {
        tag: Fast_pace_gaming_banner,
        editor: Fast_pace_gaming_banner_editor,
        props: {
                title: 'Designed for Fast-Paced Games',
                subtitle: 'Our optimizer analyzes multiple routes between your'
                    +' PC and the game server to avoid congested'
                    +' network paths.',
                section_title: 'Free Gaming Optimization',
                section_text: 'Our mission is simple: provide a stable'
                    +' connection for gamers without subscriptions or'
                    +' complicated setups.'
                    +' Download and start playing instantly.',
                button_text: 'Download for Windows',
        },
    },
    'Popular games banner': {
        tag: Popular_games_banner,
        editor: Popular_games_banner_editor,
        props: {
            title: 'Play Your Favorite Games with Hola VPN',
            button_text: 'Download Free for Windows',
        },
    },
    'Lp_iframe_template': {
        tag: Lp_iframe_template,
        editor: Lp_iframe_template_editor,
        props: {
            iframe_src: '/templates/landing-hola.html',
            page_name: 'landing-hola',
            campaign: 'intg5',
            download_url: '/download',
        },
    },

    'Bounty hero': {
        tag: Bounty_hero,
        editor: Bounty_hero_editor,
        props: {
            title: 'Hola Security Vulnerabilities Reward Program',
            description: 'Hola is committed to protecting the privacy '
                +'and security of our users. We welcome responsible '
                +'vulnerability reports and appreciate the efforts of '
                +'those who help us identify and fix security '
                +'vulnerabilities.',
            image_src: 'hero_bounty.png',
            image_alt: 'hero_bounty',
            cta_text: 'Submit a vulnerability',
        },
    },
    'Bounty program scope': {
        tag: Bounty_program_scope,
        editor: Bounty_program_scope_editor,
        props: {
            title: 'Program Scope',
            description: 'This program applies to previously unknown security '
                +'and privacy vulnerabilities affecting Hola-owned products '
                +'and services, including:',
            items: [
                {
                    title: 'Hola website: hola.org or its mirrors',
                    image_src: 'bounty_home.svg',
                    image_alt: 'home',
                },
                {
                    title: 'User accounts and subscription flows',
                    image_src: 'bounty_user.svg',
                    image_alt: 'user',
                },
                {
                    title: 'Hola browser extensions',
                    image_src: 'bounty_puzzle.svg',
                    image_alt: 'puzzel',
                },
                {
                    title: 'Hola desktop applications',
                    image_src: 'bounty_devices.svg',
                    image_alt: 'devices',
                },
                {
                    title: 'Hola mobile applications',
                    image_src: 'bounty_mobile.svg',
                    image_alt: 'mobile',
                },
                {
                    title: 'Hola Browser',
                    image_src: 'bounty_globe.svg',
                    image_alt: 'browser',
                },
                {
                    title: 'Hola-owned APIs and backend services used by '
                        +'Hola products',
                    image_src: 'bounty_settings.svg',
                    image_alt: 'settings',
                },
            ],
            footnote: '*Only the latest publicly available versions of Hola '
                +'products are considered in scope.',
        },
    },
    'Bounty reward tiers': {
        tag: Bounty_reward_tiers,
        editor: Bounty_reward_tiers_editor,
        props: {
            title: 'Rewards',
            description: 'Rewards are determined at Hola’s sole discretion '
                +'based on severity, impact, exploitability, report quality, '
                +'and whether the issue was previously known.',
            tiers: [
                {
                    title: '$50',
                    subtitle: '',
                    featured: false,
                    items: [
                        'Low-impact XSS',
                        'Low-risk CSRF',
                        'Minor security misconfiguration with limited impact',
                        'Valid security issue with limited exploitability',
                    ],
                },
                {
                    title: '$100',
                    subtitle: 'Up to',
                    featured: false,
                    items: [
                        'Stored or reflected XSS with meaningful user impact',
                        'CSRF enabling sensitive account actions',
                        'Authorization issue with limited account impact',
                        'Exposure of non-sensitive internal information',
                        'Security misconfiguration on production systems '
                            +'with practical impact',
                    ],
                },
                {
                    title: '$200',
                    subtitle: 'Up to',
                    featured: true,
                    items: [
                        'Account takeover risk',
                        'Access control flaw revealing personal info',
                        'Unauthorized access to user accounts',
                        'Sensitive data leak from production systems',
                        'Remote Code Execution in Hola app',
                        'Major privacy vulnerability',
                        'Remote Code Execution on Hola server',
                        'Critical authentication bypass in production',
                        'Vulnerability exposing sensitive data broadly',
                        'Severe vulnerability impacting many Hola users',
                    ],
                },
            ],
            footnotes: [
                '*Hola may decide to pay higher rewards for unusually '
                    +'severe vulnerabilities or lower rewards for issues '
                    +'with limited likelihood, limited impact, or '
                    +'incomplete proof of concept.',
                '*Duplicate reports are not eligible for a reward. '
                    +'The first report that clearly demonstrates a '
                    +'valid vulnerability will be considered the '
                    +'original report.',
                '*Any reward that remains unclaimed for more than two '
                    +'months may be canceled.',
            ],
        },
    },
    'Bounty vulnerability criteria': {
        tag: Bounty_vulnerability_criteria,
        editor: Bounty_vulnerability_criteria_editor,
        props: {
            groups: [
                {
                    title: 'Qualifying Vulnerabilities',
                    description: 'Any design or implementation issue that '
                        +'affects the confidentiality, integrity, or '
                        +'availability of Hola user data, user accounts, or '
                        +'Hola-owned production systems may qualify.',
                    type: 'allowed',
                    image_src: 'bounty_badge_check.svg',
                    image_alt: 'badge_check',
                    show_text: 'Show examples',
                    hide_text: 'Hide examples',
                    items: [
                        'Cross-Site Scripting',
                        'Cross-Site Request Forgery, CSRF / XSRF',
                        'Authentication or authorization bypass',
                        'Account takeover vulnerabilities',
                        'Access control issues exposing user data',
                        'Remote Code Execution affecting Hola servers',
                        'Remote Code Execution affecting Hola client '
                            +'applications',
                        'Local privilege escalation caused by Hola software',
                        'Sensitive data exposure',
                        'Security misconfiguration with meaningful impact',
                        'Vulnerabilities allowing unauthorized access to '
                            +'another user’s account, billing information, or '
                            +'personal information',
                        'Privacy-impacting flaws in Hola applications or '
                            +'services',
                        'Server-side request forgery, SSRF, with demonstrable '
                            +'security impact',
                        'Injection vulnerabilities, including SQL injection, '
                            +'command injection, or template injection',
                        'Insecure handling of authentication tokens, '
                            +'sessions, or credentials',
                    ],
                },
                {
                    title: 'Out of Scope',
                    description: 'There are several important issues that do '
                        +'not qualify for a bounty. These include specific '
                        +'cases that fall outside the established guidelines '
                        +'and criteria set forth by our bounty program.',
                    type: 'blocked',
                    image_src: 'bounty_warning.svg',
                    image_alt: 'warning',
                    show_text: 'Show issues',
                    hide_text: 'Hide issues',
                    items: [
                        'Denial-of-Service or Distributed Denial-of-Service '
                            +'attacks',
                        'High-volume automated scanning or testing',
                        'Load testing, stress testing, or traffic flooding',
                        'Attempts to access, modify, or delete data belonging '
                            +'to real Hola users',
                        'Social engineering, phishing, or attacks against '
                            +'Hola employees, users, vendors, or support '
                            +'teams',
                        'Physical attacks against Hola offices, '
                            +'infrastructure, or employees',
                        'Vulnerabilities affecting third-party websites or '
                            +'services not owned by Hola',
                        'Reports generated only by automated scanners without '
                            +'a working proof of concept',
                        'Missing security headers without a practical '
                            +'exploit',
                        'Version disclosure, banner disclosure, or software '
                            +'fingerprinting without exploitability',
                        'Cookie flags without demonstrated security impact',
                        'Rate-limiting issues without a clear security impact',
                        'Self-XSS or vulnerabilities requiring a user to '
                            +'paste code into the browser console',
                        'Clickjacking on pages with no sensitive action or '
                            +'user impact',
                        'Open redirects without a demonstrated security '
                            +'impact',
                        'Email spoofing or DMARC/SPF/DKIM issues without '
                            +'clear exploitability against Hola users',
                        'Vulnerabilities requiring a rooted or jailbroken '
                            +'device, unless the issue creates meaningful '
                            +'risk to regular users',
                        'Bugs in outdated versions of Hola products',
                        'Previously reported or already known vulnerabilities',
                        'UI/UX issues that do not create a security or '
                            +'privacy risk',
                    ],
                },
            ],
            notice: 'All participants must make a good-faith effort to avoid '
                +'privacy violations, data destruction, service disruption, '
                +'or degradation of Hola services. Failure to do so may '
                +'result in disqualification from the program.',
            cta_text: 'Submit a vulnerability',
        },
    },
    'Bounty bug reporting': {
        tag: Bounty_bug_reporting,
        editor: Bounty_bug_reporting_editor,
        props: {
            title: 'Reporting Bugs',
            description: 'Reports should be submitted in English and include '
                +'the following sections:',
            items: [
                {
                    title: 'Overview',
                    description: 'A short technical description of the '
                        +'vulnerability.',
                    default_open: false,
                },
                {
                    title: 'Affected Asset',
                    description: 'Include the affected domain, application, '
                        +'browser extension, API endpoint, operating system, '
                        +'browser, or product version.',
                    default_open: false,
                },
                {
                    title: 'Proof of Concept',
                    description: 'Please provide clear reproduction steps, '
                        +'including the test account used if applicable, the '
                        +'URLs, endpoints, or parameters involved, and any '
                        +'screenshots, videos, logs, or examples of requests '
                        +'and responses. Also, include any necessary '
                        +'configuration or environment details.',
                    default_open: true,
                },
                {
                    title: 'Impact',
                    description: 'Explain how the vulnerability could be '
                        +'exploited in a real-world scenario and what an '
                        +'attacker could gain or affect.',
                    default_open: false,
                },
                {
                    title: 'Suggested Fix',
                    description: 'If possible, describe how the issue could '
                        +'be fixed.',
                    default_open: false,
                },
                {
                    title: 'Additional Information',
                    description: 'You may include network data, sample code, '
                        +'HAR files, screenshots, videos, or any other '
                        +'supporting material. Allowed attachment types '
                        +'include: jpg, png, gif, txt, csv, wav, mp4, webm, '
                        +'flv, ogg, and wmv. Alternatively, you may provide '
                        +'a link to files uploaded to a secure cloud storage '
                        +'provider.',
                    default_open: false,
                },
            ],
        },
    },
    'Bounty security guidelines': {
        tag: Bounty_security_guidelines,
        editor: Bounty_security_guidelines_editor,
        props: {
            groups: [
                {
                    title: 'Safe Harbor',
                    description: 'We support responsible security research '
                        +'conducted in good faith.\nIf you comply with this '
                        +'policy, we will not initiate legal action against '
                        +'you for your research. To remain eligible, you '
                        +'must:',
                    panel_title: '',
                    visible_items: 3,
                    show_text: 'Show more',
                    hide_text: 'Show less',
                    reversed: false,
                    items: [
                        'Test only systems that are in scope',
                        'Use only your own accounts and test data',
                        'Avoid accessing, changing, deleting, or copying data '
                            +'that does not belong to you',
                        'Stop testing and notify us immediately if you '
                            +'encounter user data or confidential information',
                        'Avoid actions that could interrupt or degrade Hola '
                            +'services',
                        'Give us reasonable time to investigate and resolve '
                            +'the issue before public disclosure',
                        'Follow all applicable laws and regulations',
                    ],
                },
                {
                    title: 'Disclosure\nGuidelines',
                    description: 'Please do not publicly disclose the '
                        +'vulnerability until Hola has completed its '
                        +'investigation and remediation.',
                    panel_title: 'We aim to:',
                    visible_items: 3,
                    show_text: 'Show more',
                    hide_text: 'Show less',
                    reversed: true,
                    items: [
                        'Acknowledge valid reports within a reasonable '
                            +'timeframe',
                        'Investigate and reproduce reported issues',
                        'Keep researchers updated where appropriate',
                        'Resolve confirmed vulnerabilities based on severity '
                            +'and complexity',
                        'Credit researchers when appropriate and with their '
                            +'consent',
                    ],
                },
            ],
        },
    },
    'Bounty payments': {
        tag: Bounty_payments,
        editor: Bounty_payments_editor,
        props: {
            title: 'Bounty Payments',
            description: 'Bounty payments are subject to the following '
                +'restrictions:',
            items: [
                'Payments are made in US dollars, USD.',
                'Payments must comply with applicable local laws, '
                    +'regulations, and sanctions rules.',
                'You are responsible for any tax consequences resulting '
                    +'from bounty payments.',
                'If you are employed, it is your responsibility to comply '
                    +'with your employer’s policies regarding participation '
                    +'in bug bounty programs.',
                'Minors may participate, but if you are under the legal age '
                    +'required to receive payment in your jurisdiction, '
                    +'payment may need to be claimed by a parent or legal '
                    +'guardian.',
                'Hola may request identity, tax, or payment information '
                    +'before issuing a reward.',
            ],
        },
    },
    'Bounty CTA': {
        tag: Bounty_cta,
        editor: Bounty_cta_editor,
        props: {
            title: 'Thank You!',
            description: 'We appreciate the security research community’s '
            +'help in keeping Hola safe. Responsible disclosure helps us '
            +'protect our users, improve our products, and maintain trust.',
            cta_text: 'Submit a vulnerability',
            background_src: '',
        },
    },
};
